<template>
  <div class="page-header page-header-light">
    <div class="page-header-content header-elements-md-inline" style="height: 40px">
      <div class="page-title d-flex">
        <h5 style="font-size: 14px;">
          <router-link :to="{name: 'record-chunk'}">
          <i class="icon-arrow-left52 mr-2"></i>
        </router-link>
        {{title}}
        <span v-if="!title">Loading...</span>
        </h5>
        <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a>
      </div>

      <div class="header-elements d-none">
        <div class="d-flex justify-content-center">
          <slot name="right"></slot>
          <!-- <a href="#" class="btn btn-link btn-float text-default"><i class="icon-bars-alt text-primary"></i><span>Statistics</span></a>
          <a href="#" class="btn btn-link btn-float text-default"><i class="icon-calculator text-primary"></i> <span>Invoices</span></a>
          <a href="#" class="btn btn-link btn-float text-default"><i class="icon-calendar5 text-primary"></i> <span>Schedule</span></a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>
